// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"815fcca1","130":"815fcca1","253":"0a8950f8","311":"815fcca1","436":"815fcca1","547":"815fcca1","646":"815fcca1","654":"815fcca1","725":"2cfcdb84","898":"815fcca1","914":"815fcca1","983":"815fcca1","994":"815fcca1"}[chunkId] + ".chunk.css";
};